<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'independentObjectives.import'}"><i class="fa fa-plus"></i> Importar</router-link>
      <router-link class="btn btn-primary" :to="{name:'independentObjectives.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <grid-filters grid-data="theGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="theGrid" name="scorecardObjectives" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'scorecardObjectives',
  components: {
    Grid
  },
  data() {
    return {
      gridFilters: [{
        field:'independent_operator_id',
        modal:'independent-operators-modal',
        foreign: 'id',
        placeholder: 'Operador'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        }
      },
      preload: [{
        api: 'scorecard-independents/operators/lst',
        field: 'independent_operator_id'
      }],
      url: 'scorecard-independents/objectives',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'ym',
        title: 'Ano/Mês',
        width: '120px'
      },
      {
        field: 'spreads',
        title: 'Spreads',
        width: '120px',
        values: lists.yesNo
      },
      {
        field: 'independent_operator_id',
        title: 'Operador',
        width: '220px'
      },
      {
        field: 'sellin1',
        title: 'Sellin Top10',
        width: '120px'
      },
      {
        field: 'sellin2',
        title: 'Sellin Total',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'independentObjectives.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('independentObjectives.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
